/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type TrainingCourseTypeIconEnum = 'clipboard-internship' | 'problem-solving' | 'lab' | 'group-task' | 'growth' | 'classroom' | 'volunteer' | 'teamwork' | 'check-round-green' | 'observe' | 'epas' | 'goals' | 'stat-growth';

export const TrainingCourseTypeIconEnum = {
    ClipboardInternship: 'clipboard-internship' as TrainingCourseTypeIconEnum,
    ProblemSolving: 'problem-solving' as TrainingCourseTypeIconEnum,
    Lab: 'lab' as TrainingCourseTypeIconEnum,
    GroupTask: 'group-task' as TrainingCourseTypeIconEnum,
    Growth: 'growth' as TrainingCourseTypeIconEnum,
    Classroom: 'classroom' as TrainingCourseTypeIconEnum,
    Volunteer: 'volunteer' as TrainingCourseTypeIconEnum,
    Teamwork: 'teamwork' as TrainingCourseTypeIconEnum,
    CheckRoundGreen: 'check-round-green' as TrainingCourseTypeIconEnum,
    Observe: 'observe' as TrainingCourseTypeIconEnum,
    Epas: 'epas' as TrainingCourseTypeIconEnum,
    Goals: 'goals' as TrainingCourseTypeIconEnum,
    StatGrowth: 'stat-growth' as TrainingCourseTypeIconEnum
};

